import { render, staticRenderFns } from "./ExtensionType.vue?vue&type=template&id=e01064c0"
import script from "./ExtensionType.vue?vue&type=script&lang=js"
export * from "./ExtensionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports